import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import './index.css'
import Chart from "react-apexcharts";
import Image from '../assets/loading1.gif'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const COT = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [shortdata, setshortdata] = useState([]);
  const [longdata, setlongdata] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [availableDates, setAvailableDates] = useState([]);
  const [tabledata, settabledata] = useState({});

  const apikey = process.env.REACT_APP_API_KEY;
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://financialmodelingprep.com/api/v4/commitment_of_traders_report/${id}?apikey=${apikey}`
        );
        const jsonData = await response.json();
        const sampledata = {
          title: jsonData.title,
          openInterest: 34992,
          cftcCode: 13874,
          date: 'July 3, 2023',
          totalchange: 1533,
          totaltrader: 26,
          positions: {
            dealers: {
              long: 2500,
              short: 3000,
              spread: 500
            },
            assetmgr: {
              long: 1000,
              short: 800,
              spread: 200
            },
            leveragefunds: {
              long: 1800,
              short: 1600,
              spread: 200
            },
            other: {
              long: 1200,
              short: 900,
              spread: 300
            },
            nonreportable: {
              long: 500,
              short: 600,
              spread: -100
            }
          },
          change: {
            dealers: {
              long: 50,
              short: -100,
              spread: 150
            },
            assetmgr: {
              long: -50,
              short: 50,
              spread: -100
            },
            leveragefunds: {
              long: 100,
              short: 200,
              spread: -100
            },
            other: {
              long: -20,
              short: -10,
              spread: -10
            },
            nonreportable: {
              long: 30,
              short: 50,
              spread: -20
            }
          },
          pct: {
            dealers: {
              long: 5,
              short: -3,
              spread: 2
            },
            assetmgr: {
              long: -5,
              short: 6,
              spread: -1
            },
            leveragefunds: {
              long: 6,
              short: 13,
              spread: -7
            },
            other: {
              long: -1.5,
              short: -1.1,
              spread: -0.4
            },
            nonreportable: {
              long: 6,
              short: 8.3,
              spread: -2.3
            }
          },
          tarders: {
            dealers: {
              long: 12,
              short: 15,
              spread: 3
            },
            assetmgr: {
              long: 5,
              short: 7,
              spread: 2
            },
            leveragefunds: {
              long: 8,
              short: 9,
              spread: 1
            },
            other: {
              long: 3,
              short: 4,
              spread: 1
            },
            nonreportable: {
              long: 2,
              short: 3,
              spread: 1
            }
          },
          heading: ['Dealer', 'Intermediatory', 'Asset', 'Manager', 'Leverage', 'Funds', 'Other', 'Reportables', 'Nonreportable', 'Positions']
        }
        setData(jsonData);
        console.log(jsonData)
        const datesFromJsonData = jsonData.map((item) => new Date(item.date));
        setAvailableDates(datesFromJsonData);
        async function fetchData(sector, jsonData) {
          // const response1 = await fetch(`http://localhost:4000/${sector.toLowerCase()}`);
          const response1 = await fetch(`https://tradingbackend.onrender.com/${sector.toLowerCase()}`);
          const jsonData1 = await response1.json();
          console.log(jsonData1);
          try {
            const matchingobject = jsonData1.find((obj) => obj.cftcCode === jsonData[0].cftc_contract_market_code)
            console.log(matchingobject)
            if (!matchingobject) {
              const short = [sampledata.positions.dealers.short, sampledata.positions.assetmgr.short, sampledata.positions.leveragefunds.short, sampledata.positions.nonreportable.short, sampledata.positions.other.short]
              setshortdata(short);
              const long = [sampledata.positions.dealers.long, sampledata.positions.assetmgr.long, sampledata.positions.leveragefunds.long, sampledata.positions.nonreportable.long, sampledata.positions.other.long];
              setlongdata(long);
              settabledata(sampledata);
              return;
            }
            settabledata(matchingobject);
            const short = [matchingobject.positions.dealers.short, matchingobject.positions.assetmgr.short, matchingobject.positions.leveragefunds.short, matchingobject.positions.nonreportable.short, matchingobject.positions.other.short];
            setshortdata(short);
            const long = [matchingobject.positions.dealers.long, matchingobject.positions.assetmgr.long, matchingobject.positions.leveragefunds.long, matchingobject.positions.nonreportable.long, matchingobject.positions.other.long];
            setlongdata(long);
          } catch (error) {
            console.log("Error occurred:", error);
          }
        }

        if (jsonData[0].sector === "CURRENCIES") {
          fetchData("currencies", jsonData);
        } else if (jsonData[0].sector === "GRAINS") {
          fetchData("grains", jsonData);
        } else if (jsonData[0].sector === "METALS") {
          fetchData("metals", jsonData);
        } else if (jsonData[0].sector === "ENERGIES") {
          fetchData("energies", jsonData);
        } else if (jsonData[0].sector === "FINANCIALS") {
          fetchData("currencies", jsonData);
        } else if (jsonData[0].sector === "MEATS") {
          fetchData("meats", jsonData);
        } else if (jsonData[0].sector === "INDICES") {
          fetchData("meats", jsonData);
        } else if (jsonData[0].sector === "SOFTS") {
          fetchData("grains", jsonData);
        }

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);


  const handleDateSelect = (date) => {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const formattedDate = `${year}-${month}-${day}`;
    const filteredData = data.filter(item => {
      const itemDate = item.date.split(' ')[0];
      return itemDate === formattedDate;
    });
    setData(filteredData);
  };

  return (
    <div className='cotdiv'>
      {data.length > 0 ? (
        <>
          <div className="cotheader">
            <h1 className='cotheading'>COT Report :&nbsp;
              <span style={{ textTransform: "uppercase" }}>
                {data[0].market_and_exchange_names}
              </span>
            </h1>
            <h3 className='cotsubheading'>Futures Only Positions as of  {data.length > 0 ? data[0].date.split(' ')[0] : 'Loading...'}</h3>
            <p className='cotcontent'>Below is the Commitments of Traders (COT) report for {data[0].short_name} (futures only) with COT charts. This COT report for AUSTRALIAN DOLLAR is as of {data.length > 0 ? data[0].date.split(' ')[0] : 'Loading...'}. COT reports are released each Friday (except for U.S. holidays) by the CFTC. Each COT report release includes data from the previous Tuesday.</p>
          </div>
          <div className="row flex-sm-row flex-column" style={{ marginBottom: "30px" }}>
            <div className="col col-sm-8">
              <strong>{data[0].market_and_exchange_names}</strong> (CONTRACTS OF AUD 100,000)<br />
              <strong>CFTC Code : </strong>#{data[0].cftc_contract_market_code}<br />
              <strong>Open Interest: </strong><span className="number">
                {data[0].open_interest_all}
              </span> &nbsp;
              <strong>Total Changes : </strong><span className={`${data[0].change_in_open_interest_all === 0 ? 'null' : data[0].change_in_open_interest_all < 0 ? 'negative' : 'positive'}`}>{data[0].change_in_open_interest_all}</span> &nbsp;
              <strong>Total Traders : </strong><span className="number"><strong>{data[0].traders_tot_all}</strong></span>
            </div>
            <div className="col col-sm-4 text-right mt-sm-0 mt-3">
              <div className="mb-2"><strong>AS OF : </strong>
                {selectedDate ? selectedDate.toLocaleDateString() : (data.length > 0 ? data[0].date.split(' ')[0] : 'Loading...')}
              </div>
              <div className='calendarbtn'>
                <DatePicker onChange={handleDateSelect} className='past-data-datepicker btn green-btn btn-sm' placeholderText='View Historical Date' includeDates={availableDates}>
                </DatePicker>
                <i className="fa fa-calendar-plus-o calendar-icon" aria-hidden="true"></i>
              </div>
            </div>
          </div>
          {tabledata.cftcCode ? (
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>&nbsp;</th>
                    <th colSpan="3" className="left-border text-center">Long</th>
                    <th colSpan="3" className="left-border text-center">Short</th>
                    <th colSpan="3" className="left-border text-center">Spread</th>
                  </tr>
                  <tr>
                    <th></th>
                    <th className="left-border">Positions</th>
                    <th>Open Int</th>
                    <th># Traders</th>
                    <th className="left-border">Positions</th>
                    <th>Open Int</th>
                    <th># Traders</th>
                    <th className="left-border">Positions</th>
                    <th>Open Int</th>
                    <th># Traders</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>{tabledata.heading[0]}<br />{tabledata.heading[1]}</strong></td>
                    {["long", "short", "spread"].map((type) => (
                      <>
                        <td className="left-border number">
                          {tabledata.positions.dealers[type]}
                          <br />
                          <span className={`${tabledata.change.dealers[type] === 0 ? 'null' : tabledata.change.dealers[type] < 0 ? 'negative' : 'positive'}`}>
                            {tabledata.change.dealers[type]}
                          </span>
                        </td>
                        <td className="number">
                          {tabledata.pct.dealers[type]}%
                        </td>
                        <td className="number">
                          {tabledata.tarders.dealers[type]}
                        </td>
                      </>
                    ))}
                  </tr>
                  <tr>
                    <td><strong>{tabledata.heading[2]}<br />{tabledata.heading[3]}</strong></td>
                    {["long", "short", "spread"].map((type) => (
                      <>
                        <td className="left-border number">
                          {tabledata.positions.assetmgr[type]}
                          <br />
                          <span className={`${tabledata.change.assetmgr[type] === 0 ? 'null' : tabledata.change.assetmgr[type] < 0 ? 'negative' : 'positive'}`}>
                            {tabledata.change.assetmgr[type]}
                          </span>
                        </td>
                        <td className="number">
                          {tabledata.pct.assetmgr[type]}%
                        </td>
                        <td className="number">
                          {tabledata.tarders.assetmgr[type]}
                        </td>
                      </>
                    ))}
                  </tr>
                  <tr>
                    <td><strong>{tabledata.heading[4]}<br />{tabledata.heading[5]}</strong></td>
                    {["long", "short", "spread"].map((type) => (
                      <>
                        <td className="left-border number">
                          {tabledata.positions.leveragefunds[type]}
                          <br />
                          <span className={`${tabledata.change.leveragefunds[type] === 0 ? 'null' : tabledata.change.leveragefunds[type] < 0 ? 'negative' : 'positive'}`}>
                            {tabledata.change.leveragefunds[type]}
                          </span>
                        </td>
                        <td className="number">
                          {tabledata.pct.leveragefunds[type]}%
                        </td>
                        <td className="number">
                          {tabledata.tarders.leveragefunds[type]}
                        </td>
                      </>
                    ))}
                  </tr>
                  <tr>
                    <td><strong>{tabledata.heading[6]}<br />{tabledata.heading[7]}</strong></td>
                    {["long", "short", "spread"].map((type) => (
                      <>
                        <td className="left-border number">
                          {tabledata.positions.other[type]}
                          <br />
                          <span className={`${tabledata.change.other[type] === 0 ? 'null' : tabledata.change.other[type] < 0 ? 'negative' : 'positive'}`}>
                            {tabledata.change.other[type]}
                          </span>
                        </td>
                        <td className="number">
                          {tabledata.pct.other[type]}%
                        </td>
                        <td className="number">
                          {tabledata.tarders.other[type]}
                        </td>
                      </>
                    ))}
                  </tr>
                  <tr>
                    <td><strong>{tabledata.heading[8]}<br />{tabledata.heading[9]}</strong></td>
                    {["long", "short", "spread"].map((type) => (
                      <>
                        <td className="left-border number">
                          {tabledata.positions.nonreportable[type]}
                          <br />
                          <span className={`${tabledata.change.nonreportable[type] === 0 ? 'null' : tabledata.change.nonreportable[type] < 0 ? 'negative' : 'positive'}`}>
                            {tabledata.change.nonreportable[type]}
                          </span>
                        </td>
                        <td className="number">
                          {tabledata.pct.nonreportable[type]}%
                        </td>
                        <td className="number">
                          {tabledata.tarders.nonreportable[type]}
                        </td>
                      </>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          ) : (
            <p>Loading data...</p>
          )}
          {tabledata.cftcCode ? (
            <div className="charts" style={{ marginTop: "4rem" }}>
              <Chart
                options={{
                  chart: {
                    type: 'bar',
                    height: 350,
                    stacked: true,
                    stackType: '100%',
                    toolbar: {
                      show: false
                    }
                  },
                  grid: {
                    show: false,
                  },
                  yaxis: {
                    show: false,
                  },
                  responsive: [{
                    breakpoint: 480,
                    options: {
                      legend: {
                        position: 'bottom',
                        offsetX: -10,
                        offsetY: 0
                      }
                    }
                  }],
                  xaxis: {
                    categories: [`${tabledata.heading[0]}`, `${tabledata.heading[2]}`, `${tabledata.heading[4]}`, `${tabledata.heading[6]}`, `${tabledata.heading[8]}`]
                  },
                  fill: {
                    opacity: 1,
                    colors: ['#7fcea5', '#d56a72']
                  },
                  legend: {
                    position: 'right',
                    offsetX: 0,
                    offsetY: 50,
                    markers: {
                      fillColors: ['#7fcea5', '#d56a72'],
                    }
                  }
                }}
                series={
                  [
                    {
                      name: 'LONG',
                      data: longdata
                    },
                    {
                      name: 'SHORT',
                      data: shortdata
                    },
                  ]}
                type="bar"
                height={350}
              />
              <div className="chart-box" style={{ marginTop: "3rem" }}>
                <h1>Price And Net Positions</h1>
                <div id="chart-candlestick" style={{ marginBottom: "5rem" }}>
                  <Chart
                    options={{
                      chart: {
                        type: 'candlestick',
                        height: 290,
                        id: 'candles',
                        toolbar: {
                          autoSelected: 'pan',
                          show: false,
                        },
                        zoom: {
                          enabled: false,
                        },
                      },
                      plotOptions: {
                        candlestick: {
                          colors: {
                            upward: '#7fcea5',
                            downward: '#DF7D46',
                          },
                        },
                      },
                      xaxis: {
                        type: 'datetime',
                      },
                    }}
                    series={[{
                      data: [
                        {
                          x: new Date(2023, 0, 1).toISOString().split('T')[0],
                          y: [6635.65, 6651, 6629.67, 6638.24]
                        },
                        {
                          x: new Date(2023, 0, 8).toISOString().split('T')[0],
                          y: [6638.24, 6640, 6620, 6624.47]
                        },
                        {
                          x: new Date(2023, 0, 15).toISOString().split('T')[0],
                          y: [6624.53, 6636.03, 6621.68, 6624.31]
                        },
                        {
                          x: new Date(2023, 0, 22).toISOString().split('T')[0],
                          y: [6624.61, 6632.2, 6617, 6626.02]
                        },
                        {
                          x: new Date(2023, 0, 29).toISOString().split('T')[0],
                          y: [6627, 6627.62, 6584.22, 6603.02]
                        },
                        {
                          x: new Date(2023, 1, 5).toISOString().split('T')[0],
                          y: [6605, 6608.03, 6598.95, 6604.01]
                        },
                        {
                          x: new Date(2023, 1, 12).toISOString().split('T')[0],
                          y: [6604.5, 6614.4, 6602.26, 6608.02]
                        },
                        {
                          x: new Date(2023, 1, 19).toISOString().split('T')[0],
                          y: [6608.02, 6610.68, 6601.99, 6608.91]
                        },
                        {
                          x: new Date(2023, 1, 26).toISOString().split('T')[0],
                          y: [6608.91, 6618.99, 6608.01, 6612]
                        },
                        {
                          x: new Date(2023, 2, 5).toISOString().split('T')[0],
                          y: [6612, 6615.13, 6605.09, 6612]
                        },
                        {
                          x: new Date(2023, 2, 12).toISOString().split('T')[0],
                          y: [6612, 6624.12, 6608.43, 6622.95]
                        },
                        {
                          x: new Date(2023, 2, 19).toISOString().split('T')[0],
                          y: [6623.91, 6623.91, 6615, 6615.67]
                        },
                        {
                          x: new Date(2023, 2, 26).toISOString().split('T')[0],
                          y: [6618.69, 6618.74, 6610, 6610.4]
                        },
                        {
                          x: new Date(2023, 3, 2).toISOString().split('T')[0],
                          y: [6611, 6622.78, 6610.4, 6614.9]
                        },
                        {
                          x: new Date(2023, 3, 9).toISOString().split('T')[0],
                          y: [6614.9, 6626.2, 6613.33, 6623.45]
                        },
                        {
                          x: new Date(2023, 3, 16).toISOString().split('T')[0],
                          y: [6623.48, 6627, 6618.38, 6620.35]
                        },
                        {
                          x: new Date(2023, 3, 23).toISOString().split('T')[0],
                          y: [6619.43, 6620.35, 6610.05, 6615.53]
                        },
                        {
                          x: new Date(2023, 3, 30).toISOString().split('T')[0],
                          y: [6615.53, 6617.93, 6610, 6615.19]
                        },
                        {
                          x: new Date(2023, 4, 7).toISOString().split('T')[0],
                          y: [6615.19, 6621.6, 6608.2, 6620]
                        },
                        {
                          x: new Date(2023, 4, 14).toISOString().split('T')[0],
                          y: [6619.54, 6625.17, 6614.15, 6620]
                        },
                        {
                          x: new Date(2023, 4, 21).toISOString().split('T')[0],
                          y: [6620.33, 6634.15, 6617.24, 6624.61]
                        },
                        {
                          x: new Date(2023, 4, 28).toISOString().split('T')[0],
                          y: [6625.95, 6626, 6611.66, 6617.58]
                        },
                        {
                          x: new Date(2023, 5, 4).toISOString().split('T')[0],
                          y: [6619, 6625.97, 6595.27, 6598.86]
                        },
                        {
                          x: new Date(2023, 5, 11).toISOString().split('T')[0],
                          y: [6598.86, 6598.88, 6570, 6587.16]
                        },
                        {
                          x: new Date(2023, 5, 18).toISOString().split('T')[0],
                          y: [6588.86, 6600, 6580, 6593.4]
                        },
                        {
                          x: new Date(2023, 5, 25).toISOString().split('T')[0],
                          y: [6593.99, 6598.89, 6585, 6587.81]
                        },
                        {
                          x: new Date(2023, 6, 2).toISOString().split('T')[0],
                          y: [6587.81, 6592.73, 6567.14, 6578]
                        },
                        {
                          x: new Date(2023, 6, 9).toISOString().split('T')[0],
                          y: [6578.35, 6581.72, 6567.39, 6579]
                        },
                        {
                          x: new Date(2023, 6, 16).toISOString().split('T')[0],
                          y: [6579.38, 6580.92, 6566.77, 6575.96]
                        },
                        {
                          x: new Date(2023, 6, 23).toISOString().split('T')[0],
                          y: [6575.96, 6589, 6571.77, 6588.92]
                        },
                        {
                          x: new Date(2023, 6, 30).toISOString().split('T')[0],
                          y: [6588.92, 6594, 6577.55, 6589.22]
                        },
                        {
                          x: new Date(2023, 7, 6).toISOString().split('T')[0],
                          y: [6589.3, 6598.89, 6589.1, 6596.08]
                        },
                        {
                          x: new Date(2023, 7, 13).toISOString().split('T')[0],
                          y: [6597.5, 6600, 6588.39, 6596.25]
                        },
                        {
                          x: new Date(2023, 7, 20).toISOString().split('T')[0],
                          y: [6598.03, 6600, 6588.73, 6595.97]
                        },
                        {
                          x: new Date(2023, 7, 27).toISOString().split('T')[0],
                          y: [6595.97, 6602.01, 6588.17, 6602]
                        }
                      ]
                    }]}
                    type="candlestick"
                    height={290}
                  />
                </div>
                <h1>Positions Long</h1>
                <div id="chart-line" style={{ marginBottom: "5rem" }}>
                  <Chart
                    options={{
                      chart: {
                        height: 350,
                        type: 'line',
                        zoom: {
                          enabled: false
                        },
                        toolbar: {
                          autoSelected: 'pan',
                          show: false,
                        },
                      },
                      dataLabels: {
                        enabled: false
                      },
                      stroke: {
                        curve: 'straight'
                      },
                      grid: {
                        row: {
                          colors: ['#f3f3f3', 'transparent'],
                          opacity: 0.5
                        },
                      },
                      plotOptions: {
                        candlestick: {
                          colors: {
                            upward: '#7fcea5',
                            downward: '#d56a72',
                          },
                        },
                      },
                      xaxis: {
                        type: 'category', // Change this to 'category' for using month names
                        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
                      },
                    }}
                    series={[{
                      name: "Dealer",
                      data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
                    }, {
                      name: "Asset Mgr",
                      data: [30, 41, 75, 91, 19, 22, 40, 41, 158]
                    }, {
                      name: "Lev Money",
                      data: [60, 81, 105, 121, 79, 62, 90, 111, 168]
                    },
                    {
                      name: "Other Rept",
                      data: [25, 52, 30, 41, 19, 32, 10, 21, 68]
                    },
                    {
                      name: "Non Rept",
                      data: [50, 31, 55, 81, 59, 72, 100, 111, 98]
                    }

                    ]}
                    height={350}
                  />
                </div>
                <div id="chart-area" style={{ marginBottom: "5rem" }}>
                  <Chart
                    options={{
                      chart: {
                        type: 'area',
                        height: 350,
                        stacked: true,
                        events: {
                          selection: function (chart, e) {
                            console.log(new Date(e.xaxis.min))
                          }
                        },
                        zoom: {
                          enabled: false
                        },
                        toolbar: {
                          autoSelected: 'pan',
                          show: false,
                        },
                      },
                      dataLabels: {
                        enabled: false
                      },
                      stroke: {
                        curve: 'smooth'
                      },
                      fill: {
                        type: 'gradient',
                        gradient: {
                          opacityFrom: 0.6,
                          opacityTo: 0.8,
                        },
                      },
                      grid: {
                        row: {
                          colors: ['#f3f3f3', 'transparent'],
                          opacity: 0.5
                        },
                      },
                      xaxis: {
                        type: 'datetime'
                      },
                    }}
                    series={[
                      {
                        name: 'Dealer',
                        data: [
                          [1581331200000, 35],
                          [1581417600000, 20],
                          [1581504000000, 25],
                          [1581590400000, 15],
                          [1581676800000, 28],
                          [1581763200000, 32],
                          [1581849600000, 45],
                          [1581936000000, 30],
                          [1582022400000, 20],
                          [1582108800000, 18],
                          [1582195200000, 25],
                          [1582281600000, 30],
                          [1582368000000, 35],
                          [1582454400000, 40],
                          [1582540800000, 30],
                          [1582627200000, 25],
                          [1582713600000, 22],
                          [1582800000000, 20],
                          [1582886400000, 15],
                          [1582972800000, 18],
                        ],
                      },
                      {
                        name: 'Asset Mgr',
                        data: [
                          [1581331200000, 10],
                          [1581417600000, 15],
                          [1581504000000, 12],
                          [1581590400000, 8],
                          [1581676800000, 20],
                          [1581763200000, 25],
                          [1581849600000, 18],
                          [1581936000000, 15],
                          [1582022400000, 10],
                          [1582108800000, 12],
                          [1582195200000, 8],
                          [1582281600000, 15],
                          [1582368000000, 20],
                          [1582454400000, 22],
                          [1582540800000, 18],
                          [1582627200000, 15],
                          [1582713600000, 12],
                          [1582800000000, 10],
                          [1582886400000, 8],
                          [1582972800000, 12],
                        ],
                      },
                      {
                        name: 'Lev Money',
                        data: [
                          [1581331200000, 15],
                          [1581417600000, 12],
                          [1581504000000, 8],
                          [1581590400000, 10],
                          [1581676800000, 5],
                          [1581763200000, 8],
                          [1581849600000, 12],
                          [1581936000000, 10],
                          [1582022400000, 5],
                          [1582108800000, 8],
                          [1582195200000, 12],
                          [1582281600000, 15],
                          [1582368000000, 10],
                          [1582454400000, 12],
                          [1582540800000, 8],
                          [1582627200000, 10],
                          [1582713600000, 12],
                          [1582800000000, 15],
                          [1582886400000, 18],
                          [1582972800000, 10],
                        ],
                      },
                      {
                        name: 'Other Rept',
                        data: [
                          [1581331200000, 22],
                          [1581417600000, 28],
                          [1581504000000, 30],
                          [1581590400000, 25],
                          [1581676800000, 18],
                          [1581763200000, 20],
                          [1581849600000, 25],
                          [1581936000000, 28],
                          [1582022400000, 35],
                          [1582108800000, 38],
                          [1582195200000, 40],
                          [1582281600000, 36],
                          [1582368000000, 32],
                          [1582454400000, 28],
                          [1582540800000, 30],
                          [1582627200000, 32],
                          [1582713600000, 35],
                          [1582800000000, 40],
                          [1582886400000, 45],
                          [1582972800000, 50],
                        ],
                      },
                      {
                        name: 'Non Rept',
                        data: [
                          [1581331200000, 50],
                          [1581417600000, 45],
                          [1581504000000, 40],
                          [1581590400000, 35],
                          [1581676800000, 30],
                          [1581763200000, 28],
                          [1581849600000, 25],
                          [1581936000000, 22],
                          [1582022400000, 18],
                          [1582108800000, 15],
                          [1582195200000, 12],
                          [1582281600000, 10],
                          [1582368000000, 8],
                          [1582454400000, 10],
                          [1582540800000, 12],
                          [1582627200000, 15],
                          [1582713600000, 18],
                          [1582800000000, 20],
                          [1582886400000, 25],
                          [1582972800000, 30],
                        ],
                      },
                    ]}
                    height={350}
                  />
                </div>
                <h1>Positions Short</h1>
                <div id="chart-line" style={{ marginBottom: "5rem" }}>
                  <Chart
                    options={{
                      chart: {
                        height: 350,
                        type: 'line',
                        zoom: {
                          enabled: false
                        },
                        toolbar: {
                          autoSelected: 'pan',
                          show: false,
                        },
                      },
                      dataLabels: {
                        enabled: false
                      },
                      stroke: {
                        curve: 'straight'
                      },
                      grid: {
                        row: {
                          colors: ['#f3f3f3', 'transparent'],
                          opacity: 0.5
                        },
                      },
                      plotOptions: {
                        candlestick: {
                          colors: {
                            upward: '#7fcea5',
                            downward: '#d56a72',
                          },
                        },
                      },
                      xaxis: {
                        type: 'category', // Change this to 'category' for using month names
                        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
                      },
                    }}
                    series={[{
                      name: "Dealer",
                      data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
                    }, {
                      name: "Asset Mgr",
                      data: [30, 41, 75, 91, 19, 22, 40, 41, 158]
                    }, {
                      name: "Lev Money",
                      data: [60, 81, 105, 121, 79, 62, 90, 111, 168]
                    },
                    {
                      name: "Other Rept",
                      data: [25, 52, 30, 41, 19, 32, 10, 21, 68]
                    },
                    {
                      name: "Non Rept",
                      data: [50, 31, 55, 81, 59, 72, 100, 111, 98]
                    }

                    ]}
                    height={350}
                  />
                </div>
                <div id="chart-area" style={{ marginBottom: "5rem" }}>
                  <Chart
                    options={{
                      chart: {
                        type: 'area',
                        height: 350,
                        stacked: true,
                        events: {
                          selection: function (chart, e) {
                            console.log(new Date(e.xaxis.min))
                          }
                        },
                        zoom: {
                          enabled: false
                        },
                        toolbar: {
                          autoSelected: 'pan',
                          show: false,
                        },
                      },
                      dataLabels: {
                        enabled: false
                      },
                      stroke: {
                        curve: 'smooth'
                      },
                      fill: {
                        type: 'gradient',
                        gradient: {
                          opacityFrom: 0.6,
                          opacityTo: 0.8,
                        },
                      },
                      grid: {
                        row: {
                          colors: ['#f3f3f3', 'transparent'],
                          opacity: 0.5
                        },
                      },
                      xaxis: {
                        type: 'datetime'
                      },
                    }}
                    series={[
                      {
                        name: 'Dealer',
                        data: [
                          [1581331200000, 35],
                          [1581417600000, 20],
                          [1581504000000, 25],
                          [1581590400000, 15],
                          [1581676800000, 28],
                          [1581763200000, 32],
                          [1581849600000, 45],
                          [1581936000000, 30],
                          [1582022400000, 20],
                          [1582108800000, 18],
                          [1582195200000, 25],
                          [1582281600000, 30],
                          [1582368000000, 35],
                          [1582454400000, 40],
                          [1582540800000, 30],
                          [1582627200000, 25],
                          [1582713600000, 22],
                          [1582800000000, 20],
                          [1582886400000, 15],
                          [1582972800000, 18],
                        ],
                      },
                      {
                        name: 'Asset Mgr',
                        data: [
                          [1581331200000, 10],
                          [1581417600000, 15],
                          [1581504000000, 12],
                          [1581590400000, 8],
                          [1581676800000, 20],
                          [1581763200000, 25],
                          [1581849600000, 18],
                          [1581936000000, 15],
                          [1582022400000, 10],
                          [1582108800000, 12],
                          [1582195200000, 8],
                          [1582281600000, 15],
                          [1582368000000, 20],
                          [1582454400000, 22],
                          [1582540800000, 18],
                          [1582627200000, 15],
                          [1582713600000, 12],
                          [1582800000000, 10],
                          [1582886400000, 8],
                          [1582972800000, 12],
                        ],
                      },
                      {
                        name: 'Lev Money',
                        data: [
                          [1581331200000, 15],
                          [1581417600000, 12],
                          [1581504000000, 8],
                          [1581590400000, 10],
                          [1581676800000, 5],
                          [1581763200000, 8],
                          [1581849600000, 12],
                          [1581936000000, 10],
                          [1582022400000, 5],
                          [1582108800000, 8],
                          [1582195200000, 12],
                          [1582281600000, 15],
                          [1582368000000, 10],
                          [1582454400000, 12],
                          [1582540800000, 8],
                          [1582627200000, 10],
                          [1582713600000, 12],
                          [1582800000000, 15],
                          [1582886400000, 18],
                          [1582972800000, 10],
                        ],
                      },
                      {
                        name: 'Other Rept',
                        data: [
                          [1581331200000, 22],
                          [1581417600000, 28],
                          [1581504000000, 30],
                          [1581590400000, 25],
                          [1581676800000, 18],
                          [1581763200000, 20],
                          [1581849600000, 25],
                          [1581936000000, 28],
                          [1582022400000, 35],
                          [1582108800000, 38],
                          [1582195200000, 40],
                          [1582281600000, 36],
                          [1582368000000, 32],
                          [1582454400000, 28],
                          [1582540800000, 30],
                          [1582627200000, 32],
                          [1582713600000, 35],
                          [1582800000000, 40],
                          [1582886400000, 45],
                          [1582972800000, 50],
                        ],
                      },
                      {
                        name: 'Non Rept',
                        data: [
                          [1581331200000, 50],
                          [1581417600000, 45],
                          [1581504000000, 40],
                          [1581590400000, 35],
                          [1581676800000, 30],
                          [1581763200000, 28],
                          [1581849600000, 25],
                          [1581936000000, 22],
                          [1582022400000, 18],
                          [1582108800000, 15],
                          [1582195200000, 12],
                          [1582281600000, 10],
                          [1582368000000, 8],
                          [1582454400000, 10],
                          [1582540800000, 12],
                          [1582627200000, 15],
                          [1582713600000, 18],
                          [1582800000000, 20],
                          [1582886400000, 25],
                          [1582972800000, 30],
                        ],
                      },
                    ]}
                    height={350}
                  />
                </div>
              </div>
            </div>
          ) : (
            <p>Loading data...</p>
          )}
        </>
      ) : (
        <p className='text-center'><img src={Image} alt="Loading......." /></p>
      )}
    </div>
  );
}

export default COT